import { useState, useEffect, } from 'react';
import withRedux from '../OneHat/data/hoc/withRedux';
import useForceUpdate from '../OneHat/hooks/useForceUpdate';
import useOneHatData from '../OneHat/data/useOneHatData';
import Loading from '../OneHat/components/Loading';
import ScreenContainer from '../OneHat/components/ScreenContainer';
import QuestionHeader from '../components/QuestionHeader';
import QuestionInfo from '../components/QuestionInfo';
import GatedMessage from '../components/GatedMessage';
import Proofs from '../modals/Proofs';
import Player from '../components/Player';

function Question(props) {
	const {
			currentQuestion,
			actions,
		} = props,
		forceUpdate = useForceUpdate(),
		[isReady, setIsReady] = useState(false),
		[questions, Questions] = useOneHatData('Questions');

	useEffect(() => {
		actions.setPlayerIsShown(true);
		return () => {
			actions.setPlayerIsShown(false);
		};
	}, []);

	useEffect(() => {
		if (!Questions) {
			return;
		}
		
		if (Questions.isDestroyed) {
			return; // for auto-reload of Expo
		}
		
		setIsReady(true);

		Questions.ons(['load', 'change'], forceUpdate);
		return () => {
			Questions.offs(['load', 'change'], forceUpdate);
		};

	}, [Questions]);

	if (!isReady) {
		return <Loading />;
	}

	return <ScreenContainer screenName="Question">
				<Proofs />
				<QuestionHeader />
				{currentQuestion.questions__is_gated && <GatedMessage />}
				{!currentQuestion.questions__is_gated && <QuestionInfo />}
				{!currentQuestion.questions__is_gated && <Player />}
			</ScreenContainer>;
}

export default withRedux(Question, [
	'currentQuestion',
]);